import { useSearchParams } from "react-router";
import { useQuery } from "@tanstack/react-query";

import { api } from "../api/client";

const AUTH_ERROR_MESSAGES: Record<string, string> = {
  allowlist: "Sign-in is locked until ALLOWED_GOOGLE_EMAILS is configured.",
  config: "Google sign-in is not configured yet.",
  denied: "That Google account is not allowed to access this app.",
  oauth: "Google sign-in did not complete. Please try again.",
  verified: "Google did not confirm a verified email for this account.",
};

export function LoginView() {
  const [searchParams] = useSearchParams();
  const authStatusQuery = useQuery({ queryKey: ["authStatus"], queryFn: api.authStatus });

  const authError = AUTH_ERROR_MESSAGES[searchParams.get("auth_error") || ""];
  const loggedOut = searchParams.get("logged_out") === "1";

  const status = authStatusQuery.data;
  const authReady = Boolean(status?.auth_ready);
  const googleConfigured = status?.google_auth_configured ?? true;
  const allowlistConfigured = status?.allowlist_configured ?? true;

  return (
    <main className="login-page">
      <div className="login-shell">
        <section className="login-panel">
          <p className="login-kicker">Stock Assist</p>
          <h1>Sign in to explore tracked symbols.</h1>
          <p className="login-copy">Access is limited to approved Google accounts.</p>

          {authError && <div className="notice notice-error">{authError}</div>}
          {loggedOut && <div className="notice notice-success">Signed out.</div>}

          <a
            className={`google-button${authReady ? "" : " button-disabled"}`}
            href={authReady ? "/auth/google/login" : "#"}
            aria-disabled={!authReady}
          >
            <span className="google-mark">G</span>
            <span>Continue with Google</span>
          </a>

          {!googleConfigured ? (
            <p className="login-footnote">Google OAuth client settings are missing.</p>
          ) : !allowlistConfigured ? (
            <p className="login-footnote">No approved emails are configured.</p>
          ) : null}
        </section>
      </div>
    </main>
  );
}
